import { Component, OnInit, Renderer2, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../../environments/environment';
import { SessionSotrageService } from '../../../../services/session-sotrage.service';
import { User } from 'src/app/model/session/user.model';
import { CatalogosService } from '../../../../services/catalogos/catalogos.service';
import { ComunicacionService } from '../../../../services/comunicacion.service';
// #region Notificaciones
import { NotificationService } from 'src/services/notify/notify.service';
import { NotificacionesService } from 'src/services/notify/notificaciones.service';
import { iNotify } from 'src/app/model/iNotify/inotify.model';
import { AlertasService } from '../../../../services/pld/alertas.service';
import { SweetServices } from 'src/services/sweet.services';
import { HostListener } from '@angular/core';
import { MiPerfilPopupComponent } from '../../mi-perfil/mi-perfil-popup/mi-perfil-popup.component';
import { HomeService } from 'src/services/home/home.service';
// #endregion Notificaciones

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {

  selectedLanguage: string;
  public lang: string;
  public user: User;
  public traduccion = environment.traduccion;
  // #region Notificaciones
  public numNotify: number;
  notifications: [];
  isLoadingNotify = false;
  isSearchError = false;
  isHideNotify = true;//Ocultar notificaciones
  isClickedButton = false;
  total: number;
  casosResultados: [];
  reporteResultados: any[];
  totalRegistros: number;
  numPage: number;
  contador: number; 
  perfil:any;
  // #endregion Notificaciones

  public appdata:any;
  env:string;
  constructor(private translateService: TranslateService, private sssotrage: SessionSotrageService,
    private catalogoService: CatalogosService, private comunicacionService: ComunicacionService,
    // #region Notificaciones
    private alertaService: AlertasService,
    //Lee notificaciones en tiempo real
    private notificationService: NotificationService,
    //búsca detalle de notificaciones
    private notificaciones: NotificacionesService,
    private renderer: Renderer2,
    private el: ElementRef,
    private alerta: SweetServices,
    private homeService: HomeService
    // #endregion Notificaciones
  ) {
    this.selectedLanguage = comunicacionService.getLenguaje();
    this.lang = comunicacionService.getLenguaje();
    this.translateService.setDefaultLang(this.selectedLanguage);
    const browserLang = translateService.getBrowserLang();
    translateService.use(this.selectedLanguage);
    this.appdata = this.homeService.getEnvironment();
    this.env = this.appdata.licenseData.customer.isProduction
      ? '' 
      : this.appdata.licenseData.customer.environment;
    // #region Notificaciones
    window.addEventListener('beforeunload', (event) =>
      this.beforeUnloadHander(event));
    this.buscarDetalleNotificaciones();
    this.numNotify = 0;
    this.buscarNotificaciones();
    // #endregion Notificaciones    
  }

  toogleLanguage(lang: string) {
    this.translateService.use(lang);
    this.lang = lang;
    this.comunicacionService.setLenguaje(lang);
  }

  ngOnInit() {
    this.user = this.sssotrage.getCurrentUser();
    this.buscarNotificaciones();
    this.perfil = this.user.perfil;
  }

  cerrarSesion(): void {
    this.catalogoService.limpiarCatalogos(false);
    this.sssotrage.logout();
  }

  //Lee el cierre de ventana
  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    this.buscarNotificaciones();
  }

  //Lee el evento de clickear fuera de las notificaciones
  @HostListener('document:click', ['$event'])
  onClickOutside(event: Event) {
    const notifyPanelElement =
      this.el.nativeElement.querySelector('#notify-panel');
    if (!this.isClickedButton && notifyPanelElement &&
      !notifyPanelElement.contains(event.target)) {
      this.renderer.setStyle(notifyPanelElement,
        'visibility', 'hidden');
      this.isHideNotify = true;
    } else {
      this.isClickedButton = false;
    }
  }

  // #region Lectura Notificaciones
  viewNotifyWindow() {
    //Indica que el origen es haber clickado el botón
    this.isClickedButton = true;
    this.isHideNotify = this.isHideNotify ? false : true;
    let visibility = this.isHideNotify ? 'hidden' : 'visible';
    const notifyWindow = this.el.nativeElement.querySelector('#notify-panel');
    this.renderer.setStyle(notifyWindow, 'visibility', visibility);
    if (!this.isHideNotify) {
      this.isLoadingNotify = true;
      this.buscarDetalleNotificaciones();
    }
  }

  buscarDetalleNotificaciones() {
    this.isLoadingNotify = true;
    var objNotify = new iNotify();
    this.notificaciones.getNotificacion(objNotify).subscribe(response => {
      this.isLoadingNotify = false;
      if (response == null) {
        this.alerta.AlertaError('Existe un error, si persiste contacte al administrador del Sitio.');
      } else if (response.isCorrect === 'false') {
        this.alerta.AlertaError(response.message);
      } else if (response.data.total === 0) {
        this.numNotify = 0
      } else {
        this.notifications = response.data.info.result;
        this.numNotify = response.totalRegistros;
      }
    }, (err) => {
      this.isLoadingNotify = false;
      if (err.error.message == null) {
        this.alerta.AlertaCatch(err);
      } else {
        this.alerta.AlertaError(err.error.message);
      }
    });
  }

  seleccionarNotificacion(notificacionId: number) {
    this.descargar(notificacionId);
  }

  descargar(notificacionId: number) {
    this.alertaService.descargarNotificacion(notificacionId).subscribe((blob) => {
      const url = window.URL.createObjectURL(blob);
      // Generar un nombre único basado en la fecha y hora actual
      const fechaActual = new Date();
      const fechaString = fechaActual.toISOString().replace(/[:.]/g, '-'); // Formatear para evitar caracteres inválidos
      const nombreDescarga = `Reportes_${fechaString}.zip`; // Nombre final
      const a = document.createElement('a');
      a.href = url;
      a.download = nombreDescarga; // Nombre del archivo a descargar
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    });
  }

  buscarNotificaciones() {
    this.notificationService.getNotificationObservable().subscribe(message => {
      console.log(message)
      this.buscarDetalleNotificaciones();
    });
  }
  // #endregion Lectura Notificaciones  

  isMiPerfilOpen = false;
  selectedMiPerfilOption = '';

  miPerfil(opcion: string) {
    this.selectedMiPerfilOption = opcion;
    this.isMiPerfilOpen = true;
  }
}
